import React from 'react'
import { Carousel } from '@fs/zion-carousel'

type ZionCarouselProps = React.ComponentProps<typeof Carousel>

export const ZionCarousel = ({ children, ...props }: ZionCarouselProps): JSX.Element => {
  return <Carousel {...props}>{children}</Carousel>
}
